/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useState } from 'react';

export default function useDeleteConfirmation(onDialogOpened, onDialogClosed, onConfirm) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogValues, setDialogValues] = useState([]);

  const openDialog = (contacts = []) => () => {
    const values = contacts instanceof Array ? contacts : [contacts];
    setIsDialogOpen(true);
    setDialogValues(values);
    onDialogOpened(contacts);
  };

  const closeDialog = () => {
    const currentValues = dialogValues;
    setDialogValues([]);
    setIsDialogOpen(false);
    onDialogClosed(currentValues);
  };

  const confirm = contacts => async () => {
    const contactIdsToDelete = contacts.map(s => s.id);
    setIsDialogOpen(false);
    setDialogValues([]);
    onConfirm(contactIdsToDelete);
  };

  return {
    deleteDialog: {
      isOpen: isDialogOpen,
      open: openDialog,
      close: closeDialog,
      values: dialogValues,
      confirm,
    },
  };
}
